import { getHdc1Dot5MembershipId } from "../builders/getHdc1Dot5MembershipId";
import { getHdc1Dot5MembershipDetails } from "../builders/getHdc1Dot5MembershipDetails";
import { hdcAutoPayUpcomingMock, hdcInfo } from "../builders/createInsuranceBill";
import { cigHdcAutoPayBill } from "../builders/createCigBill";
import { omniCanadaSecondGearMember } from "../mockMembers";

import { MockPersona } from "./mockPersonas.types";

const hdcLevel = 2;

export const wayneLetterkenny: MockPersona = {
  key: "wayneLetterkenny",
  name: "Wayne Letterkenny",
  description: "🇨🇦 | No policies | HDC 1.5 Single-tier | Upcoming HDC Bill (autopay)",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [cigHdcAutoPayBill("1.5", { id: "1" })],
      },
      policies: {
        usa: [],
        canada: [],
      },
    },
    hdc: {
      fetch1Dot5MembershipId: getHdc1Dot5MembershipId("HDC01981376"),
      fetch1Dot5MembershipDetails: getHdc1Dot5MembershipDetails({
        level: hdcLevel,
      }),
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "wayne@letterkenny.com",
            firstName: "Wayne",
            middleName: "",
            lastName: "Letterkenny",
            mailingAddress: {
              line1: "337 Queen Street West",
              line2: "",
              city: "Letterkenny",
              state: "ON",
              postalCode: "M5V 2A4",
              country: "CANADA",
            },
            preferredPhone: "4378122783",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000030",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: omniCanadaSecondGearMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [hdcAutoPayUpcomingMock({ id: "1" })],
          outstandingBalance: hdcInfo[hdcLevel - 1].cost,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
